import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import EnglishIcon from './EnglishIcon';
import SpanishIcon from './SpanishIcon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from "react-i18next";
import { LANGUAGE_REMEMBER } from 'consts';


export default function  LanguageButton() {
  const [, i18n] = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const languages = [
    { value: 'es', Icon: SpanishIcon },
    { value: 'en', Icon: EnglishIcon }
  ];

  const handleClick = (event) => setAnchorEl(event.currentTarget);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectLangauge = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem(LANGUAGE_REMEMBER, language);
    handleClose();
  }

  return (
    <>
      <Button
        id="language-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ p: 0 }}
      >
        { i18n.language === 'es' && <SpanishIcon sx={{ height: 24, borderRadius: '4px', overflow: 'hidden' }} /> }
        { i18n.language === 'en' && <EnglishIcon sx={{ height: 24, borderRadius: '4px', overflow: 'hidden' }} /> }
        <KeyboardArrowDownIcon sx={{ color: 'white', ml: 1, transform: open ? 'rotateZ(180deg)' : 'inherit', transition: '.3s' }}/>
      </Button>
      <Menu
        id="language-menu"
        sx={{ mt: 1}}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
      >
       { languages.map(lang => (
         <MenuItem key={`${lang.value}-button`} sx={{ width: 100 }} onClick={() => handleSelectLangauge(lang.value)}>
            <lang.Icon sx={{ height: 24, borderRadius: '4px', overflow: 'hidden' }}/>
            <Typography sx={{ pl: 1 }}>
              {lang.value}
            </Typography>
         </MenuItem>
       )) }
      </Menu>
    </>
  )
}
